import { render, staticRenderFns } from "./AccessRulesEditor.vue?vue&type=template&id=05aa8aa4&scoped=true"
import script from "./AccessRulesEditor.vue?vue&type=script&lang=js"
export * from "./AccessRulesEditor.vue?vue&type=script&lang=js"
import style0 from "./AccessRulesEditor.vue?vue&type=style&index=0&id=05aa8aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa8aa4",
  null
  
)

export default component.exports